var map = {
	"./czekam-na-ciebie-F.pdf": 332,
	"./moim-pokojem-F.pdf": 554,
	"./nie-patrze-wstecz-C.pdf": 193,
	"./no-longer-slaves-F.pdf": 4078,
	"./selah-F.pdf": 4536,
	"./spiewam-chwala-F.pdf": 9762,
	"./ufac-bede-B.pdf": 1346,
	"./wszystkie-moje-mysli-C.pdf": 5770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;